<template>
  <!-- 提问 -->
  <div class="zxt-bar">
    <div class="zxt-box">
      <i class="iconfont icon-liwu"></i>
      <p>优惠服务</p>
      <!-- piao -->
      <div class="zxt-popover">
        <img
          v-if="qr"
          :src="qr.imageUrl"
          alt=""
          style="width: 100px; height: 100px"
        />
        <div class="zxt-body">
          <div class="t">
            1.添加客服微信<br />
            2.转发海报<br />
            即可获得答疑服务
          </div>
        </div>
      </div>
    </div>
    <div class="zxt-box">
      <i class="iconfont icon-houtou"></i>
      <p>课程咨询</p>
      <!-- piao -->
      <div class="zxt-popover">
        <img
          v-if="qr"
          :src="qr.imageUrl"
          alt=""
          style="width: 100px; height: 100px"
        />
        <div class="zxt-body">
          <div class="t">扫描微信二维码<br />课程和网站疑问</div>
          <div class="g">针对课程有疑问？<br />购买时遇到问题？</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCourseBanner } from "../../service";

export default {
  name: "Foot",
  data() {
    return {
      qr: null,
    };
  },
  methods: {
    getCourseBanner() {
      getCourseBanner(3)
        .then((res) => {
          console.log(res);
          if (!res.result.code) {
            // this.banners = res.result;
            console.log(res.result);
            this.qr = res.result[0];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getCourseBanner();
  },
};
</script>
<style scoped>
.zxt-bar {
  width: 70px;
  background: #ffffff;
  border-radius: 4px 4px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 0px 4px 2px rgba(250, 100, 0, 0.1);
  line-height: 40px;
  position: fixed;
  bottom: 20%;
  left: 50%;
  margin-left: 500px;
  cursor: pointer;
  z-index: 1499;
}

.zxt-box {
  position: relative;
  height: 70px;
  line-height: 1;
  box-sizing: border-box;
  padding: 12px 0;
}

.zxt-box p {
  padding-top: 2px;
}

.zxt-box:first-child {
  border-bottom: 1px solid #eeeeee;
}

.zxt-box:first-child p,
.zxt-box:first-child .iconfont {
  color: #fa6400;
  line-height: 21px;
  font-weight: 500;
  background: linear-gradient(133deg, #f10603 0%, #f7f5c9 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.zxt-box:last-child p,
.zxt-box:last-child .iconfont {
  font-weight: 500;
  color: #fa6400;
  line-height: 21px;
  background: linear-gradient(116deg, #ff4e50 0%, #f9d423 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.zxt-bar .iconfont {
  font-size: 20px;
}

@media (min-width: 1600px) {
  .zxt-bar {
    margin-left: 640px;
  }
}

@media (max-width: 1600px) {
  .zxt-bar {
    margin-left: 650px;
  }
}

.zxt-box .t {
  line-height: 16px;
  color: #fa6400 !important;
  font-size: 12px;
}

.zxt-box .g {
  line-height: 16px;
  color: #999 !important;
  font-size: 12px;
  margin-top: 10px;
}

.zxt-popover {
  position: absolute;
  width: 240px;
  z-index: 99;
  right: 80px;
  top: 0px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  background-color: #fff;
  display: none;
  position: absolute;
  display: none;
  align-items: center;
  text-align: left;
  padding: 20px;
}

.zxt-popover img {
  display: block;
  margin-right: 10px;
}

.zxt-popover .zxt-body {
  flex: 1;
}

.zxt-popover::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  background-color: #ffffff;
  top: 30%;
  width: 12px;
  height: 12px;
  right: -4px;
  transform: rotateZ(45deg);
  content: "";
}

.zxt-box:hover .zxt-popover {
  display: flex;
}
</style>
